import React, { useState, useEffect } from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";

export function AddEditGrupo(props) {
  const { onRefetch, grupo } = props;
  const [grupos, setGrupos] = useState(null);
  const [refetch] = useState(false);
  const { auth } = useAuth();

  async function getGruposApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/grupo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setGrupos(result);
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getGruposApi();
    // eslint-disable-next-line
  }, [refetch]);

  const addGrupo = async (data) => {
    try {
      await createGrupoApi(data, auth.token);
      toast.success("Grupo registrado exitosamente");
    } catch (error) {
      throw error;
    }
  };

  const updateGrupo = async (id, data) => {
    try {
      await updateGrupoApi(id, data, auth.token);
      toast.success("Grupo actualizado exitosamente");
    } catch (error) {
      throw error;
    }
  };

  async function createGrupoApi(data, token) {
    try {
      const url = `${BASE_API}/api/grupo/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      var grupoo = parseInt(data.numero_grupo);
      if (error.response && error.response.status === 400) {
        const existingGrupo = grupos.find(
          (grupo) => grupo.numero_grupo === grupoo
        );
        if (existingGrupo) {
          toast.error("Ya existe un grupo con esa descripción");
        }
      }
      throw error;
    }
  }

  async function updateGrupoApi(id, data, token) {
    try {
      const url = `${BASE_API}/api/grupo/${id}/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.patch(url, data, { headers });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.numero_grupo !== undefined) {
          toast.error(
            "campo de descripcion: " + error.response.data.numero_grupo[0]
          );
        }
      }
      throw error;
    }
  }

  const formik = useFormik({
    initialValues: initialValues(grupo),
    validationSchema: Yup.object(grupo ? updateSquema() : newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue, { resetForm }) => {
      try {
        if (grupo) await updateGrupo(grupo.id_grupo, formValue);
        else {
          await addGrupo(formValue);
          resetForm();
        }
        onRefetch();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <>
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <label>
          Número de grupo <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="numero_grupo"
          placeholder="Número de grupo"
          value={formik.values.numero_grupo}
          onChange={formik.handleChange}
          error={formik.errors.numero_grupo}
        />
        {/*<Form.Input
          name="capacidad"
          placeholder="Capacidad"
          value={formik.values.capacidad}
          onChange={formik.handleChange}
          error={formik.errors.capacidad}/> */}
        <Button
          type="submit"
          content={grupo ? "Actualizar" : "Crear"}
          style={{ backgroundColor: "#008e86", color: "white" }}
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );
}

function initialValues(datosGrupo) {
  return {
    numero_grupo: datosGrupo?.numero_grupo || "",
    capacidad: undefined,
    alumnos: datosGrupo?.alumnos || [],
  };
}

function newSchema() {
  return {
    numero_grupo: Yup.string()
      .required(true)
      .matches(/^[1-9]\d*$/, "Solo se admiten números y mayores a 0"),
    /*capacidad: Yup.string()
      .required(true)
  .matches(/^[1-9]\d*$/, "Solo se admiten números y mayores a 0"),*/
  };
}
function updateSquema() {
  return {
    numero_grupo: Yup.string()
      .required(true)
      .matches(/^[1-9]\d*$/, "Solo se admiten números y mayores a 0"),
    /*capacidad: Yup.string()
      .required(true)
      .matches(/^[1-9]\d*$/, "Solo se admiten números y mayores a 0"), */
  };
}
